import { RouterState } from 'redux-first-history';

import { AdminState } from '../components/admin/store/types';
import { AnnexDefinitionState } from '../components/agency-annex/store/types';
import { UserAttestationState } from '../components/attestations/store/types';
import { AuthState } from '../components/auth/store/types';
import { ClauseLibraryState } from '../components/clause-library/store/types';
import { DatasetInstanceState } from '../components/datasets/instances/store/types';
import { PdfState } from '../components/documents/document-viewer/store/types';
import { DocumentState } from '../components/documents/store/stateTypes';
import { DoraState } from '../components/dora/store/types';
import { HomepageState } from '../components/home/store/types';
import { NavigationState } from '../components/navigation/store/types';
import { OpinionState } from '../components/opinions/store/stateTypes';
import { PlaybookState } from '../components/playbook/store/types';
import { ApplicationState } from './types';

export const getRouterRoot = (state: ApplicationState): RouterState => state.router;
export const getAuthRoot = (state: ApplicationState): AuthState => state.auth;
export const getAdminRoot = (state: ApplicationState): AdminState => state.admin;
export const getDatasetInstanceRoot = (state: ApplicationState): DatasetInstanceState => state.datasetInstance;
export const getNavigationRoot = (state: ApplicationState): NavigationState => state.navigation;
export const getDocumentRoot = (state: ApplicationState): DocumentState => state.document;
export const getAnnexDefinitionRoot = (state: ApplicationState): AnnexDefinitionState => state.annexDefinition;
export const getOpinionRoot = (state: ApplicationState): OpinionState => state.opinion;
export const getAttestationsRoot = (state: ApplicationState): UserAttestationState => state.attestations;
export const getHomepageRoot = (state: ApplicationState): HomepageState => state.homepage;
export const getPlaybookRoot = (state: ApplicationState): PlaybookState => state.playbook;
export const getClauseLibraryRoot = (state: ApplicationState): ClauseLibraryState => state.clauseLibrary;
export const getDoraRoot = (state: ApplicationState): DoraState => state.dora;
export const getPdfRoot = (state: ApplicationState): PdfState => state.pdf;
